<template>
    <div class="battery">
        <topTitle class="top-title" :title="'移动能源运营监控调度大屏'">
            <template v-slot:topLeft>
                <div @click="batteryListshow = true">
                    {{ batteryObj.name }}
                </div>
            </template>
        </topTitle>
        <div class="content">
            <div class="battery-left">
                <battery-left :allRoundData="allRoundData" />
            </div>
            <div class="battery-center">
                <center :batteryData="batteryData" />
            </div>
            <div class="battery-right">
                <batteryRight :batteryData="batteryData"></batteryRight>
            </div>
        </div>

        <div v-if="batteryListshow" class="pop-box" @click="batteryListshow = false">
            <div class="mpop-content">
                <span class="mpop-close">+</span>
                <div>热门</div>
                <div class="flex item-box">
                    <div
                        class="pop-item"
                        v-for="(item, i) in batteryList"
                        :key="'batteryList' +i"
                        @click="change(i)">
                        {{ item.name }}
                    </div>
                </div>
                <div class="flex item-box">
                    <input class="inp-batt" v-model="inpBatteryId" @click.stop="" />
                    <button class="but-1" @click="change(0, inpBatteryId)">确定</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import topTitle from '../components/topTitle.vue'
import center from './batteryComponents/center.vue'

import batteryLeft from './batteryComponents/left.vue'
import batteryRight from './batteryComponents/right.vue'

import { dataInterface } from '@/api/dataInterfaceApi'
export default {
    components: {
        topTitle,
        batteryLeft,
        center,
        batteryRight
    },
    data() {
        return {
            batteryId: '',
            inpBatteryId: '',
            batteryListshow: false,
            batteryList: [
                {
                    name: "衡阳新园路站-电池A",
                    value: '08IPBN80032A3AB820100082'
                },
                {
                    name: "衡阳蒸湘南路站-电池A",
                    value: '08IPBN80032A3AC190200013'
                },
                {
                    name: "衡阳蒸湘南路站-电池B",
                    value: '08IPBN80032A3ABCC0200029'
                },
                {
                    name: "衡阳新园路站-电池B",
                    value: '08IPBN80032A3ABCE0100051'
                }
            ],
            batteryObj: {},
            batteryAt: 0,
            allRoundData: [
                {
                    icon: 'battery',
                    title: '当前状态',
                    value: '',
                    unit: '',
                    color: '#36FBFB'
                },
                {
                    icon: 'power',
                    title: '累计使用天数',
                    value: '',
                    unit: '天',
                    color: '#43FFB9'
                },
                {
                    icon: 'clock',
                    title: '累计里程',
                    value: '',
                    unit: '万公里',
                    color: '#179DFF'
                },
                {
                    icon: 'clock',
                    title: '累计换电次数',
                    value: '',
                    unit: '次',
                    color: '#179DFF'
                },
                {
                    icon: 'panel',
                    title: '累计充电次数',
                    value: '',
                    unit: '次',
                    color: '#36FBFB'
                },
                {
                    icon: 'panel',
                    title: '累计电量',
                    value: '',
                    unit: '万度',
                    color: '#36FBFB'
                }
            ],
            batteryData: {}
        }
    },
    provide() {
        return {
            batteryObj: () => this.batteryObj
        }
    },
    mounted() {
        this.change()
        // this.init()
    },
    methods: {
        async init() {
            let _this = this
            // 电池试试信息
            let batteryRealTimeInfo = await _this.batteryRealTimeInfo()
            // 电池信息
            let batteryInfo = await _this.batteryInfo()
            // 电池里程
            let leijilc = await _this.leijilc()

            _this.batteryData = batteryRealTimeInfo
            _this.allRoundData[0].value = batteryRealTimeInfo.statusname  || '空闲中'

            _this.allRoundData[1].value = batteryInfo.totalDay
            _this.allRoundData[2].value = (parseFloat(leijilc.totalMileage || 0, 10) / 10000).toFixed(0)
            _this.allRoundData[3].value = batteryInfo.totalExchangeNum
            _this.allRoundData[4].value = batteryInfo.totalChargeNum
            _this.allRoundData[5].value = (parseFloat(batteryInfo.totalElect || 0, 10) / 10000).toFixed(0)
            _this.$set(_this.allRoundData)

        },
        change(i, id) {
            this.batteryListshow = false
            if(id) {
                this.batteryObj = {
                    value: id,
                    name: id
                }
            } else {
                this.batteryAt = i || 0
                this.batteryObj = {
                    ...this.batteryList[this.batteryAt]
                }
            }
            this.batteryId = this.batteryObj.value
            // debugger
            this.init()
        },
        // 电池实时信息
		batteryRealTimeInfo() {
			let _this = this
            _this.batteryData = {}
            return new Promise( (resolve, reject) => {
                let params = {
                    "enCode": "TIDB-Energy-dianchixiang-dianchixinxi-shishi",
                    "@battery_id": _this.batteryId
                }
                dataInterface
                    .dataFaceApi(params)
                    .then((res) => {
                        if (!res) return;
                        console.log("电池实时信息", res)
                        let data = res[0] || {}
                        resolve(data)
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            })
		},
        // 电池信息
		batteryInfo() {
			let _this = this
            return new Promise((resolve, reject) => {
                let params = {
                    "enCode": "TiDB-Energy-dianchixiang-dianchixinxi",
                    "@battery_id": _this.batteryId
                }
                dataInterface
                    .dataFaceApi(params)
                    .then((res) => {
                        if (!res) return;
                        console.log("电池信息", res)
                        let data = res[0] || {}
                        resolve(data)
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            })
		},
        // 电池里程
		leijilc() {
			let _this = this
            return new Promise(( resolve, reject ) => {
                let params = {
                    "enCode": "TiDB-Energy-dianchixiang-dianchixinxi-leijilc",
                    "@battery_id": _this.batteryId
                }
                dataInterface
                    .dataFaceApi(params)
                    .then((res) => {
                        if (!res || !res.length) return
                        console.log("电池里程", res[0])
                        resolve(res[0])
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            })
			
		},
        // 电池单体信息
		batterySingle() {
			let _this = this;
			let params = {
				"enCode": "TiDB-Energy-dianchixiang-dianchidantixinxi",
				"@battery_id": _this.batteryId
			}
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if (!res) return;
					console.log("温度", res)
					let data = res[0] || {}
				})
				.catch((err) => {
					console.log(err);
				});
		},
    }
}
</script>

<style lang="scss" scoped>
.battery {
    height: 100%;
    background: url(~@/assets/images/energyMuseum/batterybg.png) no-repeat;
    background-size: 100% 50%;
    .content {
        height: 100%;
        position: relative;
        display: flex;
        .battery-left, .battery-right {
            width: 560px;
            flex-shrink: 0;
        }
        .battery-center {
            height: 100%;
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 20px;
        }
    }
    .pop-box {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 100;
        background: rgba(#fff, .3);
        .mpop-content {
            background: linear-gradient(180deg,rgba(35,94,92,.8),rgba(36,98,96,.8));
            width: 1400px;
            position: absolute;
            padding: 50px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            > div {
                margin-top: 20px;
            }
            .item-box {
                flex-wrap: wrap;
                .pop-item {
                    margin-right: 40px;
                }
                .inp-batt {
                    background: rgba(42,255,251,.23);
                    border: 0.003571rem solid #2afffb;
                    height: 70px;
                    width: 1000px;
                    margin-right: 40px;
                }
                .but-1 {
                    width: 200px;
                    height: 70px;
                    background: linear-gradient(180deg,rgba(10,98,96,.6),rgba(1,177,169,.6));
                    border-radius: 0.028571rem;
                }
            }
        }
        .mpop-close {
            position: absolute;
            background: linear-gradient(180deg,rgba(35,94,92,.8),rgba(36,98,96,.8));
            top: -25px;
            right: -25px;
            width: 50px;
            height: 50px;
            color: #fff;
            border: 1px solid #fff;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            transform: rotate(-45deg);
        }
    }
}
</style>